var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "layout",
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { lg: "8", "offset-lg": "2" } },
                    [
                      _c("b-row", [
                        _c("div", { attrs: { id: "system-header" } }, [
                          _c("h1", {}, [_vm._v(_vm._s(_vm.$t("systems")))])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("b-row", [
                        _c("div", { attrs: { id: "system-footer" } }, [
                          _c("h6", [_vm._v(_vm._s(_vm.$t("footer")))])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-form",
                        [
                          _vm._v(
                            "\r\n            " +
                              _vm._s(_vm.$t("serialnumber")) +
                              "\r\n            "
                          ),
                          _c("v-select", {
                            staticClass: "pb-3 style-chooser",
                            staticStyle: { content: "none" },
                            attrs: { id: "", options: _vm.systems },
                            model: {
                              value: _vm.selected,
                              callback: function($$v) {
                                _vm.selected = $$v
                              },
                              expression: "selected"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "md-6" },
                            [
                              _c(
                                "b-row",
                                { attrs: { "align-h": "start" } },
                                [
                                  this.role === "EllipseAdmin" ||
                                  this.role === "CreditDistributor"
                                    ? _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            type: "button",
                                            variant: "outline-secondary",
                                            disabled: _vm.continueEnabled
                                          },
                                          on: { click: _vm.selectSystem }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("buttons.credit"))
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "md-6" },
                            [
                              _c(
                                "b-row",
                                { attrs: { "align-h": "end" } },
                                [
                                  this.role === "EllipseAdmin" ||
                                  this.role === "EllipseTech"
                                    ? _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            type: "button",
                                            variant: "outline-secondary",
                                            disabled: _vm.continueEnabled
                                          },
                                          on: { click: _vm.systemConfiguration }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("buttons.configuration")
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b57d1e2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b57d1e2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./WebApp/components/Systems.vue
// module id = 768
// module chunks = 0